import { Box, Paper, Stack, Typography } from "@mui/material";
import { panelSx } from "../common/OssPanel";

export const OssDashboardKpiBoard = ({ items }) => (
  <Paper elevation={0} sx={{ ...panelSx, p: 0, width: "100%", flexShrink: 0, overflow: "hidden" }}>
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: {
          xs: "repeat(2, minmax(0, 1fr))",
          md: "repeat(3, minmax(0, 1fr))",
          xl: "repeat(5, minmax(0, 1fr))",
        },
      }}
    >
      {items.map((item, index) => (
        <Box
          key={item.label}
          sx={{
            minHeight: { xs: 116, md: 126, xl: 130 },
            p: { xs: 2, md: 2.3 },
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: { xs: 1.15, md: 1.4 },
            borderRight: { xl: index < items.length - 1 ? "1px solid #eef2f7" : "none" },
            borderBottom: {
              xs: index < 3 ? "1px solid #eef2f7" : "none",
              md: index < 3 ? "1px solid #eef2f7" : "none",
              xl: "none",
            },
            bgcolor: "#fff",
          }}
        >
          <Stack direction="row" alignItems="center" justifyContent="center" spacing={1.15}>
            <Box
              sx={{
                width: { xs: 40, md: 44 },
                height: { xs: 40, md: 44 },
                flexShrink: 0,
                borderRadius: "50%",
                display: "grid",
                placeItems: "center",
                color: item.color,
                bgcolor: "#f8fafc",
                border: "1px solid #e5e7eb",
                "& .MuiSvgIcon-root": {
                  display: "block",
                  fontSize: { xs: 21, md: 23 },
                  margin: 0,
                },
              }}
            >
              {item.icon}
            </Box>
            <Typography
              noWrap
              sx={{
                fontSize: { xs: "14px !important", md: "16px !important" },
                fontWeight: 900,
                color: "#334155",
                lineHeight: 1.2,
              }}
            >
              {item.label}
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="baseline" justifyContent="center" spacing={0.5}>
            <Typography
              component="span"
              sx={{
                fontSize: { xs: "32px !important", md: "40px !important" },
                fontWeight: "900 !important",
                lineHeight: 1,
                color: "#0f172a",
              }}
            >
              {item.value}
            </Typography>
            <Typography
              component="span"
              sx={{
                fontSize: { xs: "14px !important", md: "16px !important" },
                fontWeight: "800 !important",
                color: "#6b7280",
              }}
            >
              건
            </Typography>
          </Stack>
        </Box>
      ))}
    </Box>
  </Paper>
);
